import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme)=>({
    card: {
        position:'fixed',
        top:'20vh',
        left:'25%',
        width:'60%',
        zIndex:'100',
        OverflowEvent:'hidden',

      },
    cardMedia: {
        height: 0,
        paddingTop: "56.25%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        backgroundBlendMode: "lighten",
      },
      backdrop:{
        position: "fixed",
        top:' 0',
        left: '0',
        width: '100%',
        height: '100vh',
        zIndex: '10',
        background: 'rgba(0, 0, 0, 0.75)',
      }

}));
export default useStyles;